import useCoreModelsFind from '../../../hooks/useCoreModelsFind'

export default function usePatrolRoute(id) {
  return useCoreModelsFind('patrolRoute', id)
}
